import { render, staticRenderFns } from "./ColorPickerRow.vue?vue&type=template&id=c40e8bec"
import script from "./ColorPickerRow.vue?vue&type=script&lang=js"
export * from "./ColorPickerRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c40e8bec')) {
      api.createRecord('c40e8bec', component.options)
    } else {
      api.reload('c40e8bec', component.options)
    }
    module.hot.accept("./ColorPickerRow.vue?vue&type=template&id=c40e8bec", function () {
      api.rerender('c40e8bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/helper/ColorPickerRow.vue"
export default component.exports